 <!-- Template-->
 <p-toast [style]="{marginTop: '5px'}" position="top-right" key="toast"></p-toast>

 <app-template></app-template>


